import { RichTextDisplay } from "@/components";

import laborupBlueGear from "@/assets/laborup_blue_gear.svg";

const ExecutiveSummaryDisplay = ({ summary }: { summary: string }) => {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-primary-300 bg-primary-200 p-4">
      <div className="flex items-center gap-2">
        <img className="h-6 w-6" src={laborupBlueGear} />
        <p className="text-lg font-semibold">Executive Summary</p>
      </div>
      <RichTextDisplay richText={summary} />
    </div>
  );
};

export const JobPipelineCandidateSheetExecutiveSummary = ({
  summary,
}: {
  summary: string | null;
}) => {
  if (!summary) {
    return null;
  }

  return <ExecutiveSummaryDisplay summary={summary} />;
};
